import styles from './TaskPriorityCell.module.scss';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { ReactComponent as TaskPriorityMarkIcon } from '@work4all/assets/icons/task-actions/table/priority-mark.svg';

import { TicketPriority } from '@work4all/components/lib/components/entity-picker/PriorityPicker';

import { Task } from '@work4all/models/lib/Classes/Task.entity';

export type ITicketPriorityCellProps = {
  value: TicketPriority;
  row: { original: Task };
};

export const TicketPriorityCell = (props: ITicketPriorityCellProps) => {
  const { value } = props;

  if (value === TicketPriority.LOW) {
    return (
      <div className={styles.taskPriorityCellRoot}>
        <ArrowDownwardIcon sx={{ color: 'var(--brand02)' }} />
      </div>
    );
  }

  if (value === TicketPriority.HIGH) {
    return (
      <div className={styles.taskPriorityCellRoot}>
        <TaskPriorityMarkIcon />
      </div>
    );
  }

  return null;
};
